import { useDialog } from "@hooks";
import {
  useGetConsultantWorkStatusesQuery,
  useCreateConsultantWorkStatusMutation,
  useUpdateConsultantWorkStatusMutation,
  useDeleteConsultantWorkStatusMutation,
  GetConsultantWorkStatuses
} from "@bonliva-crm/graphql";

export type WorkStatusFormDialogData = { workStatusId?: string };

export const useWorkStatusStore = () => {
  const formDialog = useDialog<WorkStatusFormDialogData>();

  function useWorkStatuses(consultantId: string) {
    return useGetConsultantWorkStatusesQuery({
      fetchPolicy: "network-only",
      variables: { consultantId }
    });
  }

  const refetchQueries = [GetConsultantWorkStatuses.OperationName];

  const [createWorkStatus] = useCreateConsultantWorkStatusMutation({
    fetchPolicy: "network-only",
    refetchQueries
  });

  const [updateWorkStatus] = useUpdateConsultantWorkStatusMutation({
    fetchPolicy: "network-only",
    refetchQueries
  });

  const [deleteWorkStatus] = useDeleteConsultantWorkStatusMutation({
    fetchPolicy: "network-only",
    refetchQueries
  });

  return {
    formDialog,
    useWorkStatuses,
    createWorkStatus,
    updateWorkStatus,
    deleteWorkStatus
  };
};
